<template>
  <!-- Los datos de contacto ya están en el panel lateral: aquí, el mapa (si se activa) y lo legal -->
  <footer class="n5-pie" v-if="NOTARIA?.Theme">
    <div class="n2-contenedor">
      <div v-if="T.Footer?.MostrarMapa && urlMapa" class="n5-pie__mapa">
        <iframe :src="urlMapa" :title="'Mapa de ' + NOTARIA.Nombre" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
      <div class="n5-pie__fila">
        <div class="n2-redes" v-if="redes.length">
          <a v-for="r in redes" :key="r.icono" :href="r.url" target="_blank" rel="noopener" :aria-label="r.nombre + ' de ' + NOTARIA.Nombre">
            <v-icon size="20">{{ r.icono }}</v-icon>
          </a>
        </div>
        <span>© {{ new Date().getFullYear() }} {{ NOTARIA.Nombre }}</span>
        <nav>
          <a :href="getLocalePath('/avisolegal')">{{ $t('avisoLegal') }}</a>
          <a :href="getLocalePath('/politicacookies')">{{ $t('politicaCookies') }}</a>
          <a :href="getLocalePath('/protecciondatos')">{{ $t('proteccionDatos') }}</a>
          <a :href="getLocalePath('/accesibilidad')">{{ $t('accesibilidad') }}</a>
          <a v-if="NOTARIA.UrlDenuncias" :href="urlExterna(NOTARIA.UrlDenuncias)" target="_blank" rel="noopener">{{ $t('denuncias') }}</a>
          <NuxtLink v-if="acceso.visible('pie')" :to="acceso.enlace('pie')">{{ (acceso.textoMenu.value || tSolicitud('Encargo online')) }}</NuxtLink>
          <a href="https://controlpanel.unidata.es/">{{ $t('panelControl') }}</a>
        </nav>
      </div>
      <div v-if="T.Footer?.MostrarSubFooter" class="n5-pie__sub"><FooterSubFooter /></div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { urlExterna } from '../../composables/useNotaria2'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { $t, getLocalePath } = useUtils()
const acceso = useAccesoSolicitud()

const T = computed(() => NOTARIA.value?.Theme ?? {})
const C = computed(() => NOTARIA.value?.Contacto ?? {})
const redes = computed(() => [
  { url: C.value.Facebook, icono: 'mdi-facebook', nombre: 'Facebook' },
  { url: C.value.LinkedIn, icono: 'mdi-linkedin', nombre: 'LinkedIn' },
  { url: C.value.Twitter, icono: 'mdi-twitter', nombre: 'X' },
  { url: C.value.Instagram, icono: 'mdi-instagram', nombre: 'Instagram' },
].filter(r => r.url))
const urlMapa = computed(() => {
  const c = C.value.Coordinates
  return c && Number(c.lat) && Number(c.lng) ? `https://maps.google.com/maps?q=${c.lat},${c.lng}&z=15&output=embed` : ''
})
</script>
